import { ErrorBoundary } from 'components/common/error-boundary';
import { HitterLibrary } from 'components/sections/hitter-library';
import { HitterLibraryNew } from 'components/sections/hitter-library/new';
import { HitterProfile } from 'components/sections/hitter-library/profile';
import { HPHitterSession } from 'components/sections/hitter-library/profile/reports/hitter-session';
import { HPHitterSessionNew } from 'components/sections/hitter-library/profile/reports/hitter-session-new';
import { FF_NAME_ANALYTICS_2 } from 'enums/session-recap/enums';
import { useFeatureFlag } from 'hooks/useFeatureFlag';
import { Navigate, Route, Routes } from 'react-router-dom';
import { paths, routePaths } from 'routes/paths';

const RedirectToIndex = () => (
  <Navigate to={paths.hitterLibrary.hitters} replace />
);

export const HitterLibraryRouter = () => {
  const isAnalytics2 = useFeatureFlag(FF_NAME_ANALYTICS_2);

  return (
    <ErrorBoundary identifier="HitterLibraryRouter">
      <Routes>
        <Route path="" element={<RedirectToIndex />} />
        <Route
          path={routePaths.hitterLibrary.hitters}
          element={isAnalytics2 ? <HitterLibraryNew /> : <HitterLibrary />}
        />
        <Route
          path={routePaths.hitterLibrary.profile}
          element={<HitterProfile identifier="HitterProfile" verbose />}
        />
        <Route
          path={routePaths.hitterLibrary.session}
          element={
            isAnalytics2 ? (
              <HPHitterSessionNew identifier="HLHitterSessionNew" />
            ) : (
              <HPHitterSession identifier="HLHitterSession" />
            )
          }
        />
        <Route path="*" element={<RedirectToIndex />} />
      </Routes>
    </ErrorBoundary>
  );
};
